import { formatDistanceStrict } from 'date-fns';

const MINUTE = 60 * 1000;

const formatTimeBeforeBuild = (savedAt: Date, triggeredAt: Date): string | undefined => {
  const elapsed = triggeredAt.getTime() - savedAt.getTime();

  // A config saved after the trigger is clock skew or bad data, and the build still ran the config
  // captured at trigger time. No phrasing of "before this build" is true, so say nothing.
  if (elapsed < 0) {
    return undefined;
  }

  const delta = elapsed < MINUTE ? 'Moments' : formatDistanceStrict(savedAt, triggeredAt, { roundingMethod: 'floor' });

  return `${delta} before this build`;
};

export default formatTimeBeforeBuild;
